import { Component, input } from '@angular/core';

import { MatCheckboxModule } from '@angular/material/checkbox';
import { IReportFilter } from '../../../../utils/interfaces/report-filter';
import { IDevicesBranch, IUnit } from '../../../../utils/interfaces/unit';

@Component({
  selector: 'app-devices',
  standalone: true,
  imports: [MatCheckboxModule],
  templateUrl: './devices.component.html',
  styleUrl: './devices.component.scss',
})
export class DevicesComponent {
  filter = input.required<IReportFilter>();
  allUnits = input.required<IUnit[]>();

  handlerDevice(device: IDevicesBranch): void {
    const devices = this.filter().devicesId || [];

    if (devices.includes(device.id!)) {
      this.filter().devicesId = devices.filter((d) => d !== device.id);
      this.filter().devicesName =
        this.filter().devicesName?.filter(
          (d) => d !== device.name
        );
    } else {
      this.filter().devicesId = [...devices, device.id!];
      this.filter().devicesName = [
        ...(this.filter().devicesName ?? []),
        device.name,
      ];
    }
  }
}